import { transformDateValue } from 'core/js/FormUtils';
export const getCampaigncenterView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let campaigncenterList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Campaign Date","fieldValue":transformDataValue(data.campaigndate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Campaign Count","fieldValue":transformDataValue(data.campaigncount,"number"), "fieldType":"number"},
              
              
            ],
            'dataList': [
                
              ]
          }

          campaigncenterList.push(card);
  })
  return campaigncenterList;
}